<script>
import Player from '@vimeo/player';
import throttle from '@/helpers/throttle';

export default {
    name: 'MaterialPlayer',
    props: {
        material: { type: Object },
        allowfullscreen: { type: Boolean, default: true },
        autoplay: { type: Boolean, default: false },
    },
    data() {
        return {
            player: null,
            localVideoDataUrl: null
        }
    },
    mounted() {
        if (!this.isUseLocalVideo) {
            this.initVimeoPlayer();
        }
    },
    computed: {
        isUseLocalVideo() {
            //return location.hostname === 'localhost';
            return process.env.VUE_APP_IS_RASPBERRY_MODE;
        },
        preparedVideoUrl() {
            if (this.isUseLocalVideo) {
                return `http://localhost:8083/quizzes/${this.material.id}.mp4`;
                //return `/quizzes/${this.material.id}.mp4`;
            } else {
                let m = (this.material.vimeo_url || this.material.practice_url).match(new RegExp('/([0-9]{4,})(?:[/?]|$)'));
                return m ? 'https://player.vimeo.com/video/' + m[1] : '';
            }
        },
        //vimeoId() { return this.material.vimeo_url?.match(/\d{4,}/)[0] } // https://vimeo.com/808967138
    },
    methods: {
        onSelectLocalQuizVideo(e) {
            const file = e.target.files[0];
            this.localVideoDataUrl = URL.createObjectURL(file);
            e.target.remove();

            this.$emit('initLocalVideo', this.$refs.video);
            // currentTime
        },
        initVimeoPlayer() {
            // @see https://www.npmjs.com/package/@vimeo/player

            const player = new Player(this.$refs.iframe);
            this.player = player;

            this.$emit('init', {player});

            //this.$emit('init', {player});

            // player.on('playing', (vid) => {});
            // player.on('play', (vid) => {});
            // player.on('pause', (vid) => {});
            // player.on('ended', (vid) => {});

            // !_0161_2_1892_Ознаки осені
            /*player.getVideoTitle().then(function(title) {

            });*/

            // @todo Перевірити чи цей Event десь використовується
            this.$el.addEventListener('play', () => {
                player.play();
            });

            this.$refs.playerEl?.addEventListener('play', () => {
                player.play();
            });

            this.$refs.playerEl?.addEventListener('pause', () => {
                player.pause();
            });

            /*player.on('loaded', () => {
                //this.player.play(); // Error: Unknown player. Probably unloaded.
                //player.play(); // NotAllowedError: play() failed because the user didn't interact with the document first
            });*/

            player.on('timeupdate', ({duration, percent, seconds}) => {
                throttle(() => {
                    seconds = parseFloat(seconds.toFixed(1));
                    this.$emit('timing', {duration, percent, seconds});

                    if (this.$store.me?.is_teacher && this.$route?.name === 'topic') {
                        if (document.visibilityState === 'hidden') return;
                        if (this.material.id && this.material.topic_id) {
                            this.$store.syncPostShelterMaterial(this.material);
                        }
                    }
                }, 1000);
            });

            player.on('ended', () => {
                this.onEnded();
            });

            if (this.autoplay) {
                // NotAllowedError: play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD
                console.log('Don`t panic. Its a expected 👇: NotAllowedError: play()');
                player.play();
            }
        },
        async onEnded() {
            setTimeout(() => {
                this.$emit('ended', this.material);
            }, 333);

            if (!this.material.id) {
                return;
            }

            const params = {
                material_id: this.material.id,
                url: this.material.vimeo_url,
            };
            await this.axios.get(`hit`, {params}).then(resp => {
                this.$emit('afterHit', this.material);
            });
        },
    }
}
</script>

<template>
    <div v-if="$store.isRaspberryMode" style="margin-bottom: 20px;">
        <input type="file" @change="onSelectLocalQuizVideo" />
    </div>

    <div ref="playerEl" class="material-player qip-loading" style="position: relative; padding: 56.25% 0 0 0;">
        <!-- autoplay; fullscreen; picture-in-picture ...  + '?autoplay=1&muted=1' -->
        <iframe v-if="!$store.isRaspberryMode"
                :src="preparedVideoUrl"
                :data-origin-vimeo-url="material.vimeo_url"
                ref="iframe"
                :allowfullscreen="allowfullscreen"
                allow="autoplay"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; border-radius: 15px;"
        ></iframe>
        <template v-else>
            <video ref="video"
                   :src="localVideoDataUrl"
                   controls
                   style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></video>
        </template>
    </div>
</template>

<style scoped>
    .material-player {
        margin: 0 auto;
        /*width: min(580px, 90dvw, 100%);*/
        width: clamp(min(240px, 80dvw), 100%, calc(98dvw - 20px));
        iframe { max-height: 96dvh; }
    }
</style>
